export default function BeforeAfter() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-light text-gray-900 mb-4">
            Résultats <span className="font-semibold text-rose-500">visibles</span>
          </h2>
          <p className="text-lg text-gray-600">
            Découvrez les transformations obtenues grâce aux soins Plasma froid
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-gradient-to-br from-rose-50 to-blush-50 rounded-3xl p-8 shadow-xl">
            <div className="grid md:grid-cols-2 gap-6">
              <div className="relative">
                <div className="absolute top-4 left-4 bg-gray-900/80 text-white px-4 py-2 rounded-full text-sm font-medium z-10">
                  Avant
                </div>
                <img 
                  src="https://static.readdy.ai/image/17f891913f567fd5bf7bcc70827cac74/b9b060a0be2473bb5dbf4c6bc5733680.jpeg"
                  alt="Avant le traitement Plasma froid"
                  className="w-full h-auto rounded-2xl shadow-lg"
                />
              </div>

              <div className="relative">
                <div className="absolute top-4 left-4 bg-rose-500 text-white px-4 py-2 rounded-full text-sm font-medium z-10">
                  Après
                </div>
                <img 
                  src="https://static.readdy.ai/image/17f891913f567fd5bf7bcc70827cac74/b9b060a0be2473bb5dbf4c6bc5733680.jpeg"
                  alt="Après le traitement Plasma froid"
                  className="w-full h-auto rounded-2xl shadow-lg"
                />
              </div>
            </div>

            <div className="mt-8 text-center">
              <div className="inline-flex items-center gap-2 bg-white px-6 py-3 rounded-full shadow-md">
                <i className="ri-star-fill text-rose-500"></i>
                <span className="text-gray-700 font-medium">Résultats après traitement complet</span>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-2xl mx-auto mt-12 text-center">
          <p className="text-sm text-gray-500 italic">
            Les résultats peuvent varier selon les personnes. Photos non retouchées.
          </p>
        </div>
      </div>
    </section>
  );
}
